export default __webpack_public_path__ + "static/media/RLcarriers.86f9b353.png";